/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Sort_AscInputs */

const en_table_sort_asc = /** @type {(inputs: Table_Sort_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asc`)
};

const pt_br2_table_sort_asc = /** @type {(inputs: Table_Sort_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crescente`)
};

/**
* | output |
* | --- |
* | "Asc" |
*
* @param {Table_Sort_AscInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_sort_asc = /** @type {((inputs?: Table_Sort_AscInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Sort_AscInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_sort_asc(inputs)
	return pt_br2_table_sort_asc(inputs)
});